"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OsmQueueStatsDto = exports.TileMigrationStatsDto = exports.OsmQueueLimitsDto = exports.OsmQueuePendingJobDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class OsmQueuePendingJobDto {}
exports.OsmQueuePendingJobDto = OsmQueuePendingJobDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueuePendingJobDto.prototype, "worldTileId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueuePendingJobDto.prototype, "priority", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: ['initial_migration', 'new_overture_venues', 'manual']
}), __metadata("design:type", String)], OsmQueuePendingJobDto.prototype, "reason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Unix epoch ms when the job was first enqueued'
}), __metadata("design:type", Number)], OsmQueuePendingJobDto.prototype, "enqueuedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'How many times this tile was coalesced into one job'
}), __metadata("design:type", Number)], OsmQueuePendingJobDto.prototype, "coalesceCount", void 0);
class OsmQueueLimitsDto {}
exports.OsmQueueLimitsDto = OsmQueueLimitsDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueueLimitsDto.prototype, "maxSize", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueueLimitsDto.prototype, "debounceMs", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueueLimitsDto.prototype, "minRequestIntervalMs", void 0);
class TileMigrationStatsDto {}
exports.TileMigrationStatsDto = TileMigrationStatsDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Known world tiles stored in the database'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "totalTiles", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Tiles with a completed Overture sync'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "migratedTiles", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Known tiles that have not completed an Overture sync'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "pendingTiles", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Tiles enriched from OSM at least once'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "osmEnrichedTiles", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Migrated tiles still awaiting their first OSM enrichment'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "awaitingOsmTiles", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Percentage of known tiles with a completed Overture sync'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "progressPercent", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Non-deleted venues'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "totalVenues", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Non-deleted venues assigned to migrated tiles'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "venuesInMigratedTiles", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Non-deleted venues with a Google provider ID'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "googleBackedVenues", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Non-deleted venues with an Overture provider ID'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "overtureBackedVenues", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Non-deleted venues with an OSM provider ID'
}), __metadata("design:type", Number)], TileMigrationStatsDto.prototype, "osmBackedVenues", void 0);
class OsmQueueStatsDto {}
exports.OsmQueueStatsDto = OsmQueueStatsDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueueStatsDto.prototype, "pending", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], OsmQueueStatsDto.prototype, "inFlight", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Unix epoch ms of last Overpass request'
}), __metadata("design:type", Object)], OsmQueueStatsDto.prototype, "lastRequestAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueueStatsDto.prototype, "droppedForCapacity", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueueStatsDto.prototype, "completed", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], OsmQueueStatsDto.prototype, "failed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: OsmQueueLimitsDto
}), __metadata("design:type", OsmQueueLimitsDto)], OsmQueueStatsDto.prototype, "limits", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: TileMigrationStatsDto
}), __metadata("design:type", TileMigrationStatsDto)], OsmQueueStatsDto.prototype, "tileMigration", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [OsmQueuePendingJobDto],
  description: 'Highest-priority pending jobs (capped preview)'
}), __metadata("design:type", Array)], OsmQueueStatsDto.prototype, "pendingJobs", void 0);
//# sourceMappingURL=OsmQueueStats.dto.js.map